import { styled, css } from 'styled-components';

import { StatusBadgeType } from '.';

const themeWaiting = css`
    background: #ffb822;
    color: #1f2547;
`;

const themeSuccess = css`
    background: #00d9de;
`;

const themeAlert = css`
    background: #fd397a;
`;

const themeAlertDark = css`
    background: #1f2547;
`;

const themeClosed = css`
    background: #a9adbc;
`;

const themeProcessing = css`
    background: #f6f8fa;

    > div {
        color: #1f2547;
    }
`;

const themeBuyout = css`
    background: #226dff;
`;

export const StyledStatusBadgeWrapper = styled.div<{ typeTheme: StatusBadgeType }>`
    display: inline-block;
    border-radius: 32px;

    > div {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 4px 12px;
        height: 28px;
        color: #fff;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 120%;
        white-space: nowrap;
    }
    ${(props) => props.typeTheme === 'waiting' && themeWaiting};
    ${(props) => props.typeTheme === 'success' && themeSuccess};
    ${(props) => props.typeTheme === 'alert' && themeAlert};
    ${(props) => props.typeTheme === 'alertDark' && themeAlertDark};
    ${(props) => props.typeTheme === 'closed' && themeClosed};
    ${(props) => props.typeTheme === 'processing' && themeProcessing};
    ${(props) => props.typeTheme === 'buyout' && themeBuyout};
`;
